var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jionPicker"},[_vm._v(" 申请成为选菜妈妈宣传页 -- 保留页面后续开发 ")])}
var staticRenderFns = []

export { render, staticRenderFns }